import { type PropsWithChildren } from 'react';
import { CommunicationContext } from '../../model/CommunicationContext';
import { useCommunications } from '../../model/useCommunications';

export const CommunicationProvider = ({ children }: PropsWithChildren) => {
    const communications = useCommunications();

    return <CommunicationContext.Provider value={communications}>{children}</CommunicationContext.Provider>;
};
